/**
 * O componente recebe as variáveis explicadas abaixo
 *
 * @param {HTMLElement} el - Elemento DOM que seleciona o componente em si
 * @param {Object} params  - Parâmetros para serem utilizados
 */

const $el = $(el);
const $btnClose    = $el.find('.btn-close');
const $form        = $el.find('.form');
const $cellphone   = $form.find('[name="phoneData"]');
const $objective   = $form.find('[name="objective"]');
const $valueInvest = $form.find('[name="valueInvest"]');
const $btRegister  = $form.find('[type="submit"]');
const $btnOk       = $form.find('.btn-ok');
const $successful  = $el.find('.success-screen');
const $stepOne     = $el.find('.step-one');
const $stepTwo     = $el.find('.step-two');

const $stepPatforms  = $el.find('.step-platforms');
const $platformsList = $el.find('.platforms-list');

const $numAditionalAplication = $el.find('.aditional-aplication');
const $numMinAplication       = $el.find('.min-aplication');
const $numMinBalance          = $el.find('.min-balance');
const $titleModal             = $el.find('.title-modal .title-grey');
const $inputFund              = $el.find('[name="fund"]');

let step = 1;

$valueInvest.mask('#.##0,00', { reverse: true });
let numMinAplication;

$el.on('open', function (e, atributes) {
    //get all keys from object to variables
    const {
        aditionalAplication,
        minAplication,
        minBalance,
        platforms,
        productName,
        isInstitucional
    } = atributes;

    $inputFund.val(productName);
    $titleModal.html(productName);

    numMinAplication = minAplication;

    if(platforms) {
        $platformsList.html('');

        platforms.forEach(element => {
            $platformsList.append(`
            <a href="${ element.link.url }" target="_blank">
                <span>${ element.title }</span>

                <svg class="svg-arrow-right">
                    <use xlink:href="#svg-arrow-right" xlink:title="Acessar" />
                </svg>
            </a>
            `);
        });
    }

    $numAditionalAplication.html(aditionalAplication.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'}));
    $numMinAplication.html(minAplication.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'}));
    $numMinBalance.html(minBalance.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'}));

    $el.addClass('active');
    $body.addClass('modal-opened');

    $valueInvest.data('min', numMinAplication);

    if (isInstitucional) {
        $el.addClass('institucional');
        $stepPatforms.hide();
        $stepOne.hide();

        $stepTwo.show();
        step++;
    }
    // $form.valid();
});

$btnClose.on('click', function () {
    $body.removeClass('modal-opened');
    $el.removeClass('active');

    $stepOne.show();
    $stepPatforms.hide();
    $stepTwo.hide();

    $form[0].reset();
    $form.validate().resetForm();
});

$platformsList.on('click', 'a', function (e) {
    const category = $('[data-open-modal][data-product-name="'+$inputFund.val()+'"]').data('track-category');
    const name = slugfy($(this).find('span').text()).replace('-', '_');

    dataLayer.push({
        event: 'gaEvent',
        eventAction: 'plataformas_parceiras-'+name,
        eventCategory: category,
        eventLabel: window.trackLabel,
        eventName:'investir_fundo-asa',
    });

    step++;
});

$btnOk.on('click', function (e) {
    e.preventDefault();

    $stepPatforms.hide();
    $stepOne.hide();
    $stepTwo.hide();

    if(parseInt($valueInvest.val().replace('.', '')) < 50000) {
        $stepPatforms.show();
    } else {
        $stepTwo.show();
    }

    const itensChecked = $objective.filter(':checked').map(function() {
        return $(this).val();
    }).get();

    const category = $('[data-open-modal][data-product-name="'+$inputFund.val()+'"]').data('track-category');

    dataLayer.push({
        event: 'gaEvent',
        eventAction: 'clique-'+itensChecked.join('-'),
        eventCategory: category,
        eventLabel: window.trackLabel,
        eventName:'investir_fundo-asa',
    });

    step++;
});

function checkStep(form) {
    if(step === 1) {
        if(form.numberOfInvalids() > 0) {
            $btnOk.attr('disabled', true);

            $form.valid();
        } else {
            $btnOk.removeAttr('disabled');
        }
    } else if (step === 2) {
        if(form.numberOfInvalids() > 0) {
            $btRegister.attr('disabled', true);

            $form.valid();
        } else {
            $btRegister.removeAttr('disabled');
        }
    }
}

const SPMaskBehavior = function (val) {
    return val.replace(/\D/g, '').length === 11 ? '(00) 00000-0000' : '(00) 0000-00009';
},
spOptions = {
    onKeyPress: function(val, e, field, options) {
        field.mask(SPMaskBehavior.apply({}, arguments), options);
    }
};

$.validator.addMethod("currency", function(value, element) {
        const min   = $valueInvest.data('min');
        const valor = parseInt(value.replaceAll('.', ''));

        if(valor >= min) {
            return (this.optional(element) || true);
        } else {
            return (this.optional(element) || false);
        }
    },
    `Aplicação mínima não atingida`
);

$.validator.addMethod("datebr", function(value, element) {
        var check = false;
        var re = /^\d{1,2}\/\d{1,2}\/\d{4}$/;

        if( re.test(value)){
            var adata = value.split('/');
            var gg = parseInt(adata[0],10);
            var mm = parseInt(adata[1],10);
            var aaaa = parseInt(adata[2],10);
            var xdata = new Date(aaaa,mm-1,gg);
            if ( ( xdata.getFullYear() == aaaa ) && ( xdata.getMonth () == mm - 1 ) && ( xdata.getDate() == gg ) )
            check = true;
            else
            check = false;
        } else
        check = false;
        return this.optional(element) || check;
    },
    "Insira uma data válida"
);

$.validator.addMethod('cellphone', function (value, element) {
    value = value.replace("(","");
    value = value.replace(")", "");
    value = value.replace("-", "");
    value = value.replace(" ", "").trim();

    if (value == '0000000000') {
        return (this.optional(element) || false);
    } else if (value == '00000000000') {
        return (this.optional(element) || false);
    }

    if (["00", "01", "02", "03", , "04", , "05", , "06", , "07", , "08", "09", "10"]
    .indexOf(value.substring(0, 2)) != -1) {
        return (this.optional(element) || false);
    }
    if (value.length < 10 || value.length > 11) {
        return (this.optional(element) || false);
    }
    if (["6", "7", "8", "9"].indexOf(value.substring(2, 3)) == -1) {
        return (this.optional(element) || false);
    }
    return (this.optional(element) || true);
}, 'Informe um número de telefone celular válido!');

let form;
form = $form.validate({
    highlight: function(element, errorClass, validClass) {
        const $elm  = $(element).parents('[data-component]');

        $elm.addClass(errorClass).removeClass(validClass);

        return false;
    },
    unhighlight: function(element, errorClass, validClass) {
        const $elm  = $(element).parents('[data-component]');

        $elm.removeClass(errorClass).addClass(validClass);

        return false;
    },
    errorPlacement: function(error, element) {
        element.parent().after(error);

        return false
    },
    onfocusout: function(element) {
        this.element(element);
        checkStep(form);
    },
    onkeyup: function(element) {
        this.element(element);
        checkStep(form);
    },
    onclick: function(element) {
        this.element(element);
        checkStep(form);
    },

    rules: {
        objective: {
            required: true
        },
        valueInvest: {
            currency: true,
            required: true
        },
        nameData: {
            required: true,
        },
        emailData: {
            required: true,
            email: true
        },
        phoneData: {
            required: true,
            cellphone: true
        }
    },
    submitHandler: function(form) {
        const formData = $(form).serialize();

         const category = $('[data-open-modal][data-product-name="'+$inputFund.val()+'"]').data('track-category');

        dataLayer.push({
            event: 'gaEvent',
            eventAction: 'distribuição_direta-enviar',
            eventCategory: category,
            eventLabel: window.trackLabel,
            eventName:'investir_fundo-asa',
        });

        $.post(window.location.href, formData, function(response) {
            $form.hide();
            $successful.show();

            // const category = 'Seja_nosso_cliente';
            // const action   = 'cliente_cadastrado';

            // $document.trigger('remoteTrack', [category, action]);

            // window.location.href = window.location.href;

        }, 'json').fail(function(response) {
            let message = '';

            if(response.responseJSON.errors.name) {
                message += 'Erro nome: '+response.responseJSON.errors.name[0]+"\r\n";
            }
            if(response.responseJSON.errors.birth_date) {
                message += 'Erro data de nascimento: '+response.responseJSON.errors.birth_date[0]+"\r\n";
            }
            if(response.responseJSON.errors.cpf) {
                message += 'Erro CPF: '+response.responseJSON.errors.cpf[0]+"\r\n";
            }
            if(response.responseJSON.errors.phone) {
                message += 'Erro telefone: '+response.responseJSON.errors.phone[0]+"\r\n";
            }
            if(response.responseJSON.errors.email) {
                message += 'Erro e-mail: '+response.responseJSON.errors.email[0]+"\r\n";
            }
            if(response.responseJSON.errors.segments) {
                message += 'Erro segmentos: '+response.responseJSON.errors.segments[0]+"\r\n";
            }

            alert(message);
        });
    }
});

jQuery.extend(jQuery.validator.messages, {
    required: "Este campo &eacute; obrigatório.",
    remote: "Por favor, corrija este campo.",
    email: "Por favor, forne&ccedil;a um endere&ccedil;o eletr&ocirc;nico v&aacute;lido.",
    url: "Por favor, forne&ccedil;a uma URL v&aacute;lida.",
    date: "Por favor, forne&ccedil;a uma data v&aacute;lida.",
    dateISO: "Por favor, forne&ccedil;a uma data v&aacute;lida (ISO).",
    number: "Por favor, forne&ccedil;a um n&uacute;mero v&aacute;lido.",
    digits: "Por favor, forne&ccedil;a somente d&iacute;gitos.",
    creditcard: "Por favor, forne&ccedil;a um cart&atilde;o de cr&eacute;dito v&aacute;lido.",
    equalTo: "Por favor, forne&ccedil;a o mesmo valor novamente.",
    accept: "Por favor, forne&ccedil;a um valor com uma extens&atilde;o v&aacute;lida.",
    maxlength: jQuery.validator.format("Por favor, forne&ccedil;a n&atilde;o mais que {0} caracteres."),
    minlength: jQuery.validator.format("Por favor, forne&ccedil;a ao menos {0} caracteres."),
    rangelength: jQuery.validator.format("Por favor, forne&ccedil;a um valor entre {0} e {1} caracteres de comprimento."),
    range: jQuery.validator.format("Por favor, forne&ccedil;a um valor entre {0} e {1}."),
    max: jQuery.validator.format("Por favor, forne&ccedil;a um valor menor ou igual a {0}."),
    min: jQuery.validator.format("Por favor, forne&ccedil;a um valor maior ou igual a {0}.")
});

// $form.valid();

$cellphone.mask(SPMaskBehavior, spOptions);
